import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createItemEntry = createAsyncThunk('createItemEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertItem`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateItemEntry = createAsyncThunk('updateItemEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateItem`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchItemCode = createAsyncThunk('fetchItemCode', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getitemcode`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchItemData = createAsyncThunk('fetchItemData', async (id) => {
    try {
        const endpoint = id ? `getItemlist&itemId=${id}` : `getItemlist`;
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleItem = createAsyncThunk('fetchSingleItem', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getItemlist&itemId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleItem = createAsyncThunk('deleteSingleItem', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteItem&itemId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


// itemMaterial
export const insertItemMaterial = createAsyncThunk('insertItemMaterial', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertItemMaterial`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchItemMaterialData = createAsyncThunk('fetchItemMaterialData', async (id) => {
    try {
        const endpoint = id ? `getItemMaterialList&itemId=${id}` : 'getItemMaterialList';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
       // console.log("response=>",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const delItemMaterial = createAsyncThunk('delItemMaterial', async (id) => {
    const {itemId, brandId} = id;
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteItemMaterial&itemId=${itemId}&brandId=${brandId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const itemSlice = createSlice({
    name: 'ItemData',
    initialState: {
        isLoading: false,
        item: null,
        icode: null,
        deleteItem: null,
        singleItem: null,
        material: null,
        delmaterial: null,
        isError: false
    },

    extraReducers: (builder) => {

        builder.addCase(fetchItemCode.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchItemCode.fulfilled, (state, action) => {
            state.isLoading = false;
            state.icode = action.payload;
        });
        builder.addCase(fetchItemCode.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchItemData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchItemData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.item = action.payload;
        });
        builder.addCase(fetchItemData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleItem.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleItem.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteItem = action.payload;
        });
        builder.addCase(deleteSingleItem.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleItem.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleItem.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleItem = action.payload;
        });
        builder.addCase(fetchSingleItem.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchItemMaterialData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchItemMaterialData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.material = action.payload;
        });
        builder.addCase(fetchItemMaterialData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        
        builder.addCase(delItemMaterial.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(delItemMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delmaterial = action.payload;
        });
        builder.addCase(delItemMaterial.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default itemSlice.reducer;
